<template>
  <section>
    <h4 class="form-card-header">{{ $t('registration.password-info') }}</h4>
    <div ref="generalInfoForm" class="form-card-form">
      <div>
        <label for="pi_password">{{ $t('registration.password') }}:<span class="text-danger">*</span></label>
        <input
          id="pi_password"
          name="password"
          size="sm"
          type="password"
          class="pi-input"
          v-model="v$.form.password.$model"
          @blur="v$.form.password.$touch()"
        />
        <div class="error-message" v-show="v$.form.password.$errors.length">
          <div v-show="!v$.form.password.$errors.required">{{ $t('helper.please-fill') }}</div>
          <div v-show="!v$.form.password.$errors.min">{{ $t('helper.min-text-count', { slot: '8' }) }}</div>
        </div>
      </div>

      <div>
        <label for="pi_password_confirmation">{{ $t('registration.password-confirmation') }}:<span class="text-danger">*</span></label>
        <input
          id="pi_password_confirmation"
          name="password_confirmation"
          size="sm"
          type="password"
          class="pi-input"
          v-model="v$.form.confirmation.$model"
          @blur="v$.form.confirmation.$touch()"
        />
        <div class="error-message" v-show="v$.form.confirmation.$errors.length">
          <div v-show="!v$.form.confirmation.$errors.required">{{ $t('helper.please-fill') }}</div>
          <div v-show="!v$.form.confirmation.$errors.min">{{ $t('helper.min-text-count', { slot: '8' }) }}</div>
          <div v-show="!v$.form.confirmation.$errors.sameAs">{{ $t('helper.password-match') }}</div>
        </div>
      </div>

      <section class="sub-step-buttons-container">
        <ic-button size="tn" type="button" color="grey" @click="previous" class="d-flex align-items-center mr-3"><i class="sr sr-chevron-left"></i>{{ $t('button.previous') }}</ic-button>
        <ic-button size="tn" type="button" variant="success"  @click="next" class="d-flex align-items-center ml-3">{{ $t('button.complete') }} <i class="sr sr-chevron-right"></i></ic-button>
      </section>
    </div>
  </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  props: {
    email: {
      type: String
    }
  },
  data() {
    return {
      form: {
        password: null,
        confirmation: null,
      },
    }
  },
  validations() {
    return {
      form: {
        password: { required, min: minLength(8) },
        confirmation: { required, min: minLength(8), sameAs: sameAs(this.form.password) },
      }
    }
  },
  methods: {
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async next() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        document.querySelector("#registration-form-personal").submit();
      } else {
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    },
  },
}
</script>